// const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		// preventSortOfField: {},
		buttonContext: 'mailingUrl',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'nl_mailingUrls',
		rowActionsProperties: {
			colWidth: '80px',
		// 	colSpan: 1,
		// 	rowSpan: 2
		},
		rowActions: {
		// 	delete: true,
			edit: true,
		// 	customs: [{
		// 		buttonType: 'showDuplicate',
		// 		buttonContext: 'mailing'
		// 	}]
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'nrOfClickSubscribers',
				direction: 'desc'
			}]
		}
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				var mailingID = (this.resourceData || {}).mailingID || 0;
				if(mailingID){
					this.model.mailingID = mailingID;

					resourceFilters = resourceFilters || {};

					resourceFilters.baseFilters = resourceFilters.baseFilters || {};
					resourceFilters.baseFilters.mailingID = mailingID;

					resourceFilters.filters = resourceFilters.filters || {};
				}
			}
			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID && this.model.controller) {
				var mailingUrlAttributes = (rowData || {}).attributes || {};

				// open url if necessary
				if(buttonMode === undefined){
					if(mailingUrlAttributes.linkUrl){
						window.open(mailingUrlAttributes.linkUrl);
					}
				} else if(this.model.mailingID && mailingUrlAttributes.mailingUrlID){
					if(mailingUrlAttributes.nrOfClickSubscribers > 0){
						return this.performAndStoreAction(
							'showEdit_mailingUrlSubscribers_inEffect',
							this.prepareAction('showEdit_mailingUrlSubscribers', undefined, {
								subscriberSpecifics: {
									mailingID: this.model.mailingID,
									postProcessingOptions: {
										isPostProcessing: 	true,
										mailingUrlID: 		mailingUrlAttributes.mailingUrlID,
									}
								}
							}),
							true
						);
					} else {
						return this.performAction(
							this.prepareAction('message', undefined, {
								messageDisplay: {
									message: 'error:newsletter.mailingUrls.showEdit.subscribers.empty'
								}
							})
						);
					}
				}
			}
		},
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_newsletter_mailingUrls_controller', function(controller){
					self.model.controller = controller
				});
			}
		}
	}
}